import * as React from "react";
import { Layout, Dropdown, Menu, Icon, Avatar, Divider } from "antd";
import VhIconCommon from "../vh-icon-common/VhIconCommon";
import logo from "./logo.png";

import "antd/lib/layout/style";
import "antd/lib/dropdown/style";
import "antd/lib/menu/style";
import "antd/lib/avatar/style";

import "./VhHeader.scss";

/**
 * 应用类型
 *
 * @export
 * @interface VhApp
 */
export interface VhApp {
  /**
   * appId
   *
   * @type {string}
   * @memberof VhApp
   */
  appId: string;
  /**
   * appCode
   *
   * @type {string}
   * @memberof VhApp
   */
  appCode: string;
  /**
   * 应用名称
   *
   * @type {string}
   * @memberof VhApp
   */
  appName: string;
  /**
   * 应用链接地址
   *
   * @type {string}
   * @memberof VhApp
   */
  appUrl?: string;
  /**
   * 应用文字图标
   *
   * @type {string}
   * @memberof VhApp
   */
  appFontName?: string;
  /**
   * 文字图标颜色
   *
   * @type {string}
   * @memberof VhApp
   */
  appFontColor?: string;
  /**
   * 显示方式 1：内嵌 2：外链
   *
   * @type {("1" | "2")}
   * @memberof VhApp
   */
  displayMode?: "1" | "2";
  /**
   * 是否常用 0：非常用 1：常用
   *
   * @type {("0" | "1")}
   * @memberof VhApp
   */
  settingFlag?: "0" | "1";
  /**
   * 分组 1：下拉 2：头部
   *
   * @type {("1" | "2")}
   * @memberof VhApp
   */
  groupId?: "1" | "2";
}

/**
 * 头部属性声明
 *
 * @interface VhHeaderProps
 */
export interface VhHeaderProps {
  /**
   * 公司logo
   *
   * @type {*}
   * @memberof VhHeaderProps
   */
  logo?: string;

  /**
   * 点击logo主页跳转地址
   *
   * @type {string}
   * @memberof VhHeaderProps
   */
  homePage?: string;

  /**
   * 用户照片
   *
   * @type {string}
   * @memberof VhHeaderProps
   */
  picture?: string;

  /**
   * 用户名称
   *
   * @type {string}
   * @memberof VhHeaderProps
   */
  name?: string;

  /**
   * 当前用户所拥有应用列表
   *
   * @type {boolean}
   * @memberof VhHeaderProps
   */
  appList: VhApp[];

  /**
   * 退出
   *
   * @memberof VhHeaderProps
   */
  onLogout?: () => void;
}

interface VhHeaderState {
  selectedKey: string;
}

/**
 * 头部设置
 * @class VhHeader
 * @extends {React.Component}
 */
class VhHeader extends React.Component<VhHeaderProps, VhHeaderState> {
  /**
   * Creates an instance of VhHeader.
   * @param {VhHeaderProps} props
   * @memberof VhHeader
   */
  constructor(props: VhHeaderProps) {
    super(props);

    this.state = {
      selectedKey: ""
    };
  }

  /**
   * 切换头部menu
   *
   * @memberof VhHeader
   */
  public onMenuChange = (e: any) => {
    this.setState({
      selectedKey: e.key
    });
  }

  /**
   * 登出
   *
   * @memberof VhHeader
   */
  public onLogout = () => {
    if (this.props.onLogout) {
      this.props.onLogout();
    }
  }

  /**
   * 打开提醒页面
   *
   * @memberof VhHeader
   */
  public onShowNotice = () => {
    window.open("http://message.viphrm.com/#!/", "_blank");
  }

  /**
   * 渲染
   *
   * @returns
   * @memberof VhHeader
   */
  public render() {
    // 右侧用户信息下拉显示的应用列表
    const dropdownAppList = this.props.appList.filter((app: VhApp) => app.groupId === "1");

    return (
      <Layout.Header className="vh-header" style={ { backgroundColor: "#fff" } }>
        <a href={ this.props.homePage || "/" }>
          <img src={ this.props.logo || logo } className="logo" />
        </a>
        <Menu mode="horizontal" className="vh-nav" selectedKeys={[this.state.selectedKey]} onClick={ this.onMenuChange }>
          <Menu.Item key="1" className="ant-menu-item-active">
            <a href={ this.props.homePage || "/" }>首页</a>
            <div className="selected-nav-border" />
          </Menu.Item>
        </Menu>
        {/* <ul className="vh-nav">
          <li>
            <a href={ this.props.homePage || "/" }>首页</a>
            <div className="selected-nav-border" />
          </li>
        </ul> */}

        <Dropdown overlay={
          <Menu>
            <Menu.Item key="2">
              <a style={ {paddingLeft: 20, paddingRight: 20} } href={ `${ process.env.REACT_APP_ENV === "pro" ? "https" : "http" }://${ process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : "" }config.viphrm.com/personal` }>
                <VhIconCommon type="ms-personal" style={ {marginRight: 8} } />个人中心
              </a>
            </Menu.Item>
            {
              dropdownAppList.map((app: VhApp) => (
                <Menu.Item key={ app.appCode }>
                  <a style={ {paddingLeft: 20, paddingRight: 20} } href={ app.appUrl }>
                    <VhIconCommon type={ app.appFontName && app.appFontName.startsWith("ms-") ? app.appFontName : "ms-more-app" } style={ {marginRight: 8} } />{ app.appName }
                  </a>
                </Menu.Item>
              ))
            }
            {/* <Menu.Item key="3">
              <a style={ {paddingLeft: 20, paddingRight: 20} } href={ `${ process.env.REACT_APP_ENV === "pro" ? "https" : "http" }://${ process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : "" }config.viphrm.com/company` }>
                <VhIconCommon type="ms-set" style={ {marginRight: 8} } />公司设置
              </a>
            </Menu.Item>
            <Menu.Item key="4">
              <a style={ {paddingLeft: 20, paddingRight: 20} } href={ `${ process.env.REACT_APP_ENV === "pro" ? "https" : "http" }://${ process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : "" }config.viphrm.com/user` }>
                <VhIconCommon type="ms-user" style={ {marginRight: 8} } />用户管理
              </a>
            </Menu.Item> */}
            <Menu.Item key="1">
              <a style={ {paddingLeft: 20, paddingRight: 20} } href="javascript:;" onClick={ this.onLogout }>
                <VhIconCommon type="ms-quit" style={ {marginRight: 8} } />退出
              </a>
            </Menu.Item>
          </Menu>
        }>
          <div className="user-info">
            { this.props.name ? (this.props.name.length > 20 ? (this.props.name.substr(0, 19) + "...") : this.props.name) : "" }
            <Avatar size={ 30 } src={ this.props.picture } style={ {margin: "0 7px", backgroundColor: "#ddd"} }>
              <VhIconCommon type="ms-avater-gray" />
            </Avatar>
            <Icon type="down" />
          </div>
        </Dropdown>
        <div className="notice">
          <VhIconCommon style={ {fontSize: 16} } type="ms-bell" onClick={ this.onShowNotice } />
          <Divider type="vertical" style={ {margin: "0 32px 0 24px"} } />
        </div>
      </Layout.Header>
    )
  }
}

export default VhHeader;
